import { createSlice } from '@reduxjs/toolkit';
import { recentTrxHistoryRequest } from './types';

export interface State {
  data?: any;
  error?: any;
  loading: boolean;
}

const initialState: State = {
  data: undefined,
  error: undefined,
  loading: false,
};

export const counterSlice = createSlice({
  name: recentTrxHistoryRequest,
  initialState,
  reducers: {
    getTrxHistoryData: () => {},
    trxHistoryApiCallLoadingRequest: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    trxHistoryApiCallSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    trxHistoryApiCallFailure: (state, action) => {
      if (state.data !== undefined) {
        state.data = undefined;
      }
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getTrxHistoryData,
  trxHistoryApiCallLoadingRequest,
  trxHistoryApiCallSuccess,
  trxHistoryApiCallFailure,
} = counterSlice.actions;

export default counterSlice.reducer;
